import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        // =============================================================
        // Step 0: Landing page
        // =============================================================
        case 'godt-at-vide':
            nextPage = 'om-anmeldelsen';
            break;

        // =============================================================
        // Step 1: About the luggage
        // =============================================================
        case 'om-anmeldelsen':
            nextPage = 'om-forsinket-bagage';

            const kindOfClaim = getValueOrDefault(formConfig, formValues, 'kindOfClaim').value;

            if (kindOfClaim === 'delayedLuggage') {
                nextPage = 'om-forsinket-bagage';
            } else if (kindOfClaim === 'lostLuggage') {
                nextPage = 'tidspunkt-for-mistet-bagage';
            }

            break;
        case 'om-forsinket-bagage':
            nextPage = 'er-bagagen-returneret';
            const whenWasLuggageDelayed = getValueOrDefault(formConfig, formValues, 'whenWasLuggageDelayed').value;

            if (whenWasLuggageDelayed === 'outboundTrip') {
                nextPage = 'er-bagagen-returneret';
            } else if (whenWasLuggageDelayed === 'returnTrip') {
                nextPage = 'rejsens-formaal';
            }

            break;
        case 'er-bagagen-returneret':
            nextPage = 'dato-for-modtagelsen';

            const hasTheLuggageArrived = getValueOrDefault(formConfig, formValues, 'hasTheLuggageArrived').value;

            if (hasTheLuggageArrived === 'Ja') {
                nextPage = 'dato-for-modtagelsen';
            } else if (hasTheLuggageArrived === 'Nej') {
                nextPage = 'bagage-husstanden';
            }

            break;
        case 'dato-for-modtagelsen':
            nextPage = 'bagage-husstanden';
            break;

        case 'tidspunkt-for-mistet-bagage':
            nextPage = 'er-bagagen-returneret-2';

            const whenWasLuggageLost = getValueOrDefault(formConfig, formValues, 'whenWasLuggageLost').value;

            if (whenWasLuggageLost === 'outboundTrip') {
                nextPage = 'er-bagagen-returneret-2';
            } else if (whenWasLuggageLost === 'returnTrip') {
                nextPage = 'om-erstatning';
            }

            break;
        case 'er-bagagen-returneret-2':
            nextPage = 'bagage-husstanden';

            const delayHasAlreadyBeenReported = getValueOrDefault(
                formConfig,
                formValues,
                'delayHasAlreadyBeenReported'
            ).value;
            if (delayHasAlreadyBeenReported === 'Ja') {
                nextPage = 'om-erstatning';
            }

            break;

        case 'bagage-husstanden':
            nextPage = 'om-erstatningskoeb';
            break;

        case 'om-erstatningskoeb':
            nextPage = 'om-erstatning';
            break;
        case 'om-erstatning':
            nextPage = 'rejsens-formaal';

            const haveAlreadyReceivedReimbursement = getValueOrDefault(
                formConfig,
                formValues,
                'haveAlreadyReceivedReimbursement'
            ).value;
            if (haveAlreadyReceivedReimbursement === 'Ja') {
                nextPage = 'om-beløb';
            }

            break;
        case 'om-beløb':
            nextPage = 'rejsens-formaal';
            break;

        // =============================================================
        // Step 2: About the trip
        // =============================================================
        case 'rejsens-formaal':
            nextPage = 'rejsens-destination';
            break;
        case 'rejsens-destination':
            nextPage = 'rejsedatoer';
            break;
        case 'rejsedatoer':
            nextPage = 'dokumentation';
            break;

        // =============================================================
        // Step 4: Documentation
        // =============================================================
        case 'dokumentation':
            nextPage = 'virksomhedsoplysninger';
            break;
        case 'virksomhedsoplysninger':
            nextPage = 'forsikringsmaegler';
            break;

        case 'forsikringsmaegler':
            nextPage = 'om-virksomheden';
            break;

        case 'om-virksomheden':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;

        // =============================================================
        // Step 6: Summery
        // =============================================================
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
